export default __webpack_public_path__ + "static/locale-23c84686a64f83fb5d6b65dcfa50c936.png";